import { OptionFilter } from '../filters';
import { PERISCOPE_FILTER_PLACEHOLDER } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { useApiResource } from '@hooks';
export const ModifiedByFilter = ({ onChange, sonarObjectId }) => {
    const { loading, resource } = useApiResource(`v3/core/sonar-objects/${sonarObjectId}/timelines/users`);
    const userOptions = useMemo(() => {
        var _a;
        return ((_a = resource === null || resource === void 0 ? void 0 : resource.userNames) !== null && _a !== void 0 ? _a : []).map((user) => ({
            label: user,
            value: user
        }));
    }, [resource === null || resource === void 0 ? void 0 : resource.userNames]);
    return React.createElement(OptionFilter, { loading: loading, onChange: (value) => onChange({ userNames: [value] }), options: userOptions, placeholder: PERISCOPE_FILTER_PLACEHOLDER.FILTER_BY_MODIFIED_BY });
};
